import { $api } from './interceptor';
import { ICardsStatistics, UserCard } from '../types/cards';

const cardsApi = () => {
  const getStatistics = async () => {
    const { data } = await $api.get<ICardsStatistics>('/api/cards/statistics');
    return data;
  };

  const getUserCards = async (userId: string) => {
    const { data } = await $api.get<UserCard[]>(
      `/api/cards/user-cards/${userId}`
    );
    return data;
  };

  return {
    getStatistics,
    getUserCards,
  };
};

export const cardsService = cardsApi();
